import { Button } from "@mui/material"
import { isHandledError } from "@pharmupp/p3-front-commons"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { CPMemberCardDialog } from "./CPMemberCardDialog"
import { CPMemberCardErrorDialog } from "./ErrorDialog/CPMemberCardErrorDialog"
import { useCPMemberActions } from "./useCPMemberActions"

interface CPUserCardActionsProps {
  isActive: boolean
  isActivatable: boolean
  userFullName: string
  userId: string
  isCurrentUser: boolean
  canUpdate: boolean
  userEmail: string
}

const HTTP_ALREADY_EXIST_ERROR = 409

export const CPMemberCardActions = ({
  isActive,
  isActivatable,
  userFullName,
  userId,
  userEmail,
  isCurrentUser,
  canUpdate,
}: CPUserCardActionsProps) => {
  const navigate = useNavigate()
  const { activateMembership, isLoading } = useCPMemberActions(userId)
  const [open, setIsOpen] = useState(false)
  const [errorModalConf, setIsErrorModalConf] = useState({
    open: false,
    userAlreadyExist: false,
  })

  const validateAction = async () => {
    if (isActivatable) {
      await activateMembership(undefined, {
        onSuccess: () => {
          setIsOpen(false)
        },
        onError: (err) => {
          setIsOpen(false)
          setIsErrorModalConf(() => ({
            open: true,
            userAlreadyExist:
              isHandledError(err) && err.statusCode === HTTP_ALREADY_EXIST_ERROR,
          }))
        },
      })
    } else {
      if (isCurrentUser) {
        navigate("/mon-compte/mon-profil")
      } else {
        navigate(`/mon-compte/mes-utilisateurs/${userId}`)
      }
      setIsOpen(false)
    }
  }

  if (!isActive) {
    return (
      <>
        <Button variant="contained" size="large" onClick={() => setIsOpen(true)}>
          Ouvrir accès CSE
        </Button>
        <CPMemberCardDialog
          open={open}
          validateAction={validateAction}
          isActivatable={isActivatable}
          userFullName={userFullName}
          cancelAction={() => setIsOpen(false)}
          validateEnabled={!isLoading}
          canUpdate={canUpdate}
        />
        <CPMemberCardErrorDialog
          open={errorModalConf.open}
          onClose={() => setIsErrorModalConf((prev) => ({ ...prev, open: false }))}
          userFullName={userFullName}
          userEmail={userEmail}
          userAlreadyExist={errorModalConf.userAlreadyExist}
        />
      </>
    )
  }

  return <div />
}
